import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './index.css';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin.includes('localhost:3000') ? 'http://localhost:3001' : '');

const LogsView = ({ onClose }) => {
  const { hasPermission } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    action: '',
    resourceType: '',
    userId: ''
  });

  useEffect(() => {
    loadLogs();
  }, [filters]);

  const loadLogs = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.action) params.append('action', filters.action);
      if (filters.resourceType) params.append('resourceType', filters.resourceType);
      if (filters.userId) params.append('userId', filters.userId);
      
      const response = await axios.get(`${API_URL}/api/logs?${params}`);
      setLogs(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Erreur lors du chargement des logs:', err);
      setLoading(false);
    }
  };

  const formatAction = (action) => {
    const actionMap = {
      'login.success': '✅ Connexion réussie',
      'login.failed': '❌ Tentative de connexion échouée',
      'pack.create': '📦 Pack créé',
      'pack.update': '✏️ Pack modifié',
      'pack.delete': '🗑️ Pack supprimé',
      'pack.download': '⬇️ Pack téléchargé',
      'user.create': '👤 Utilisateur créé',
      'user.update': '✏️ Utilisateur modifié',
      'user.delete': '🗑️ Utilisateur supprimé'
    };
    return actionMap[action] || action;
  };

  if (!hasPermission('logs.view')) {
    return null;
  }

  return (
    <div className="admin-panel">
      <div className="admin-panel-header">
        <h2>Logs d'Activité</h2>
        <button className="btn btn-secondary" onClick={onClose}>
          Fermer
        </button>
      </div>

      <div className="logs-filters">
        <div className="filter-group">
          <label>Action:</label>
          <select
            value={filters.action}
            onChange={(e) => setFilters({ ...filters, action: e.target.value })}
          >
            <option value="">Toutes</option>
            <option value="login.success">Connexion réussie</option>
            <option value="login.failed">Connexion échouée</option>
            <option value="pack.create">Création de pack</option>
            <option value="pack.update">Modification de pack</option>
            <option value="pack.delete">Suppression de pack</option>
            <option value="pack.download">Téléchargement de pack</option>
            <option value="user.create">Création d'utilisateur</option>
            <option value="user.update">Modification d'utilisateur</option>
            <option value="user.delete">Suppression d'utilisateur</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Type de ressource:</label>
          <select
            value={filters.resourceType}
            onChange={(e) => setFilters({ ...filters, resourceType: e.target.value })}
          >
            <option value="">Tous</option>
            <option value="pack">Pack</option>
            <option value="user">Utilisateur</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading">Chargement...</div>
      ) : (
        <div className="logs-table">
          <table>
            <thead>
              <tr>
                <th>Date/Heure</th>
                <th>Utilisateur</th>
                <th>Action</th>
                <th>Ressource</th>
                <th>Détails</th>
              </tr>
            </thead>
            <tbody>
              {logs.slice(0, 100).map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.createdAt).toLocaleString()}</td>
                  <td>
                    {log.username || 'Anonyme'}
                    {log.details && JSON.parse(log.details).authMethod === 'api_token' && (
                      <div style={{ fontSize: '0.8em', color: '#a88d39', marginTop: '2px' }}>
                        🔑 Token: {JSON.parse(log.details).tokenName}
                      </div>
                    )}
                  </td>
                  <td>
                    {formatAction(log.action)}
                    {log.details && JSON.parse(log.details).authMethod === 'api_token' && (
                      <span className="api-badge" style={{ 
                        marginLeft: '8px', 
                        fontSize: '9px', 
                        background: 'rgba(168, 141, 57, 0.2)', 
                        color: '#a88d39', 
                        padding: '2px 5px', 
                        borderRadius: '4px',
                        border: '1px solid rgba(168, 141, 57, 0.3)'
                      }}>API</span>
                    )}
                  </td>
                  <td>
                    {log.resourceType && (
                      <span className="resource-badge">
                        {log.resourceType} {log.resourceId ? `#${log.resourceId.substring(0, 8)}` : ''}
                      </span>
                    )}
                  </td>
                  <td className="log-details">
                    {log.details && (
                      <details>
                        <summary>Voir détails</summary>
                        <pre>{JSON.stringify(JSON.parse(log.details), null, 2)}</pre>
                      </details>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LogsView;
